import { render, staticRenderFns } from "./ModelsPage.vue?vue&type=template&id=71f9f3b2&scoped=true"
import script from "./ModelsPage.vue?vue&type=script&lang=js"
export * from "./ModelsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9f3b2",
  null
  
)

export default component.exports